import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Tabs, Tab, Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '100%',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.grey,
    '& button': {
      fontSize: '16px',
      minWidth: 200,
      width: 200,
      padding: theme.spacing(1.5, 2),
      marginBottom: theme.spacing(2),
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  tabPanel: {
    flex: 1,
    padding: theme.spacing(3),
  },
}));

const TabPanel = props => {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className={className}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  className: PropTypes.string,
};

const VerticalTabs = ({ tabsData, activeTab, onTabChange }) => {
  const classes = useStyles();
  const [value, setValue] = useState(activeTab || 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onTabChange) {
      onTabChange(event, {
        tabIndex: newValue,
        alias: tabsData[newValue]?.alias,
      });
    }
  };

  useEffect(() => {
    if (activeTab !== undefined && activeTab !== null) {
      setValue(activeTab);
    }
  }, [activeTab]);

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs"
        indicatorColor="primary"
        textColor="inherit"
        className={classes.tabs}
      >
        {tabsData.map((tab, index) => (
          <Tab
            key={tab.alias}
            label={tab.label}
            id={`vertical-tab-${index}`}
            aria-controls={`vertical-tabpanel-${index}`}
          />
        ))}
      </Tabs>
      {tabsData.map((tab, index) => (
        <TabPanel key={tab.alias} value={value} index={index} className={classes.tabPanel}>
          {tab.Component}
        </TabPanel>
      ))}
    </div>
  );
};

VerticalTabs.defaultProps = {
  onTabChange: () => {},
  activeTab: 0,
};

VerticalTabs.propTypes = {
  tabsData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      alias: PropTypes.string.isRequired,
      Component: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]).isRequired,
    }),
  ).isRequired,
  onTabChange: PropTypes.func,
  activeTab: PropTypes.number,
};

export default VerticalTabs;
